//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { filter, find, groupBy, map, get, uniqBy } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState, useRef, memo } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { Check, Search } from '@mui/icons-material';
import { Col, Spin, Skeleton } from 'antd';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { TableBg } from "utils/assets/images";
import COLOR from 'utils/constants/color';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Visibility } from '@mui/icons-material';
import { Modal, TablePagination } from '@mui/material';
import { Drawer } from 'antd';
import AssignmentReview from 'features/forms/AssignmentReview';
import AssignmentReviewSkeleton from 'components/gradebook/AssignmentReviewSkeleton';
import SpinLoader from 'components/Loader/SpinLoader';
import { handleListSubmissionsByAssignmentAndClass } from 'store/submissions/thunks';
import { useAllBook } from 'store/books/selectors';
import * as Sentry from '@sentry/react';
import { TootipWrapper } from 'components/TooltipWrapper';
import FlatList from "flatlist-react";
import { useDispatch } from 'react-redux';
import { useCurrentUser } from 'store/users/selectors';
import { handleGetStudentSubmissionDetailsProficiency } from 'store/standardexams';
import { useReactToPrint } from 'react-to-print';
import { useMobileDetect, useTabletDetection } from 'containers/chat/hooks';
import { useFullScreenTabDetect } from 'containers/chat/hooks';
import { useOrientation } from 'components/hooks';
import { addPrintableClass, removePrintableClass } from 'utils/methods/textMethod';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { Rnd } from 'react-rnd';
import SentryWrap from 'components/Sentry';
const getDistrictFlagModalRndDefaults = () => {
    if (typeof window === 'undefined') {
        return { x: 80, y: 120 };
    }
    const panelW = Math.min(Math.max(window.innerWidth * 0.28, 280), 420);
    return {
        x: Math.max(8, Math.round((window.innerWidth - panelW) / 2)),
        y: Math.max(64, Math.round(window.innerHeight * 0.08)),
    };
};

const ACTIVE_BTN_COLOR = `linear-gradient(to bottom right, ${COLOR.indigo100} , ${COLOR.indigo300})`
const DEACTIVE_BTN_COLOR = `linear-gradient(to right, ${COLOR.lightseagreen100} , ${COLOR.lightseagreen200})`
const getBgColor = (isActive) => isActive ? ACTIVE_BTN_COLOR : DEACTIVE_BTN_COLOR
const PLACEMNETCOLOR = [COLOR.greentrue, COLOR.green900, COLOR.yellow, COLOR.blueish100, COLOR.orange100, COLOR.radish100, , COLOR.red]
const ACIFL_LEVEL = ['ADV HIGH ', 'ADV MID', 'ADV LOW', 'INTER HIGH', 'INTER MID', 'INTER LOW', 'NOVICE HIGH', 'NOVICE MID', 'NOVICE LOW', 'MISSING']
const ACIFL_LEVEL_ABBR = ['AH ', 'AM', 'AL', 'IH', 'IM', 'IL', 'NH', 'NM', 'NL', 'FA']
const EXAM_LABELS = ['Interpretativa(A)', 'Interpretativa(B)', 'Comprensión lit..', 'Comprensión aud..', 'Comunicación int..', 'Presentación']
const EXAM_LABELS_FULL = ['Interpretativa(A)', 'Interpretativa(B)', 'Comprensión literaria', 'Comprensión auditiva', 'Comunicación interpersonal', 'Presentación oral informal']
import PrintIcon from '@mui/icons-material/Print';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip as AntdTooltip } from 'antd';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LabelList,
} from "recharts";
const SECTION_MAX_POINTS = ['',20, 20, 12, 14, 17, 17];

const filterDistrictProficiencyGradesByActiveUser = (grades) =>
  (Array.isArray(grades) ? grades : []).filter((row) => row?.user?.active !== false);

const ChartWrap = styled.div`
  width: 100%;
  //height:30vh;
  aspect-ratio: 4 / 3;
//   max-height: 280px;

  @media (max-width: 900px) { aspect-ratio: 3 / 4; min-height: 300px; }
  @media (max-width: 600px) { aspect-ratio: 1 / 1.1; min-height: 320px; }

  @media print {
    max-height: 400px !important;
    width: 100% !important;
    & svg text {
      opacity: 1 !important;
      visibility: visible !important;
      display: block !important;
    }
    & .recharts-tooltip-cursor,
    & .recharts-tooltip-cursor-fill,
    & .recharts-active-shape,
    & .recharts-reference-line,
    & .recharts-tooltip-wrapper {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }

    & svg {
      shape-rendering: crispEdges;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    & .recharts-bar-rectangle {
      fill-opacity: 1 !important;
      stroke: none !important;
    }

    & rect[fill="rgba(0,0,0,0.06)"],
    & rect[fill="rgba(0,0,0,0)"] {
      display: none !important;
      visibility: hidden !important;
    }

    & text {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }
`;

const RndWrapper = styled.div`
  @media print {
    position: static !important;
    transform: none !important;
    width: 100% !important;
    height: auto !important;
    z-index: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    page-break-before: auto !important;
    break-before: auto !important;
    
    & > div {
      position: static !important;
      transform: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  }
`;

const ModalWrapper = styled.div`
  position: relative;

  @media print {
    position: static !important;
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    page-break-before: auto !important;
    break-before: auto !important;
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  cursor: pointer;
  background-color: red;
  border-radius: 100%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (pointer: coarse) {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
  }

  @media print {
    display: none !important;
  }
`;

const PrintButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #000;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  cursor: pointer;
  margin-right: 25px;

  @media print {
    display: none !important;
  }
`;

const PrintContent = styled.div`
  background-color: #f6f6f6;
  border-radius: 13px;
  border: 1px solid #000;
  padding: 20px;
  max-width: 80vw;
  max-height: 70vh;

  @media print {
    & svg text {
      opacity: 1 !important;
      visibility: visible !important;
      display: block !important;
    }
    & text {
      opacity: 1 !important;
      visibility: visible !important;
    }
    position: relative !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 20px !important;
    background-color: white !important;
    border: 1px solid #000 !important;
    border-radius: 0 !important;
    page-break-inside: avoid;
    break-inside: avoid;
    overflow: visible !important;

    & > div {
      page-break-inside: avoid;
      break-inside: avoid;
      overflow: visible !important;
    }

    & .recharts-tooltip-cursor,
    & .recharts-tooltip-cursor-fill,
    & .recharts-active-shape,
    & .recharts-reference-line,
    & .recharts-tooltip-wrapper,
    & rect[fill="rgba(0,0,0,0.06)"],
    & rect[fill="rgba(0,0,0,0)"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }

    & svg {
      shape-rendering: crispEdges;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    & .recharts-bar-rectangle {
      fill-opacity: 1 !important;
      stroke: none !important;
    }

    @page {
      size: letter;
      margin: 15mm;
    }
  }
`;

const data = [
    { name: "Nov High",  value: 10 },
    { name: "Int Low", value: 12 },
    { name: "Int Mid",value: 15 },
    { name: "Int High",value: 25 },
    { name: "Adv Low",value: 35 },
    { name: "Adv Mid",value: 50 },
    { name: "Adv High",value: 60 },
  ];
  
  
  const domainData = [
    { name: "Listening",  value: 0 },
    { name: "Speaking",value: 0 },
    { name: "Reading", value: 0 },
    { name: "Writing",  value: 0 },
  ];

  const flagData = [
    {
      title: "Red = Urgent Support (high 50% failing, downward trend).",backgroundcolor:'linear-gradient(180deg,#ef476f,#d7265e)',
    },
    {
      title: "Orange = Needs Attention (moderate 25% failing, stagnant growth).", backgroundcolor:'linear-gradient(180deg, #FFB703, #FB8500)',
    },
    {
      title: "Green = Sufficient Support (low 10% failing, stable growth).", backgroundcolor:'linear-gradient(180deg, #03989e, #03989e)'
    }
  ]
  

function containsNumber(arr) {
    return arr.some(item => !isNaN(item) && typeof item !== 'boolean');
}

const hasNumericGrade = (value) => {
    if (value === '-' || value === null || value === undefined || value === '') return false;
    const num = Number(value);
    return !Number.isNaN(num) && num >= 0;
};

const PLACEMENT_COLUMN_WIDTH = 140;

const CellCenter = styled.span`
    display: block;
    width: 100%;
    text-align: center;
    line-height: 1.2;
    margin-right: 18px;
`;

const PlacementCellContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    flex-wrap: wrap;
`;

const EyeIconSlot = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    opacity: 0;
    transition: opacity 0.15s ease;
    pointer-events: none;
`;

const GradeCellContent = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    max-width: 100%;
    line-height: 1.2;
    cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};

    &:hover ${EyeIconSlot} {
        opacity: 1;
    }

    &:focus-visible ${EyeIconSlot} {
        opacity: 1;
    }
`;

const GradeCellValue = styled.span`
    line-height: 1.2;
    flex-shrink: 0;
`;

const GradeCellWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

const CombinedCellRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    align-items: stretch;
`;

const CombinedColumnGroup = styled.div`
    display: flex;
    flex-shrink: 0;
    background-color: ${(p) => (p.$striped ? 'rgb(242,248,254)' : 'transparent')};
`;

const GradeTableRow = styled.div`
    display: flex;
    flex-direction: row;
`;

const openSubmissionReview = (event, user, assignmentId, onViewSubmission) => {
    event.stopPropagation();
    onViewSubmission(user, assignmentId, user.class_id || user.classId);
};

const renderGradeCell = (value, assignmentId, user, onViewSubmission) => {
    if (value === '-') {
        return (
            <CellCenter>
                <AntdTooltip trigger="hover" title={assignmentId?"No submission":"Not Assigned"}>{assignmentId?"-":"NA"}</AntdTooltip>
            </CellCenter>
        );
    }
    const showEye = hasNumericGrade(value) && assignmentId;
    const handleOpen = (event) => openSubmissionReview(event, user, assignmentId, onViewSubmission);
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOpen(event);
        }
    };
    const gradeContent = (
        <GradeCellContent
            $clickable={showEye}
            role={showEye ? 'button' : undefined}
            tabIndex={showEye ? 0 : undefined}
            onClick={showEye ? handleOpen : undefined}
            onKeyDown={showEye ? handleKeyDown : undefined}
        >
            <GradeCellValue>{value}</GradeCellValue>
            {showEye ? (
                <EyeIconSlot>
                    <Visibility sx={{ fontSize: 16 }} />
                </EyeIconSlot>
            ) : null}
        </GradeCellContent>
    );

    return (
        <GradeCellWrapper>
            {showEye ? (
                <AntdTooltip trigger="hover" title="View submission">
                    {gradeContent}
                </AntdTooltip>
            ) : (
                gradeContent
            )}
        </GradeCellWrapper>
    );
};

const renderPlacementCell = (placement, submissions, checkMarkFn) => (
    <PlacementCellContent>
        <PlacementText textColor={getPlacemEntColor(placement)}>{placement}</PlacementText>
        {checkMarkFn ? checkMarkFn(submissions) : null}
    </PlacementCellContent>
);
const VideoContainer = styled.div`
    height: auto;
    flex: 1;
    justify-content: center;
`;

const ContentLoading = ({ isLoading, isClose }) => {
    return (
        <Modal
            open={isLoading}
        >
            <VideoContainer>
                <Spin size="large" style={{ position: 'absolute', top: '50%', left: '50%' }} />
            </VideoContainer>
        </Modal>
    )
};

const DomainsPerformanceChart = memo(({ data, color }) => {
    return (
        <ChartWrap>
            <ResponsiveContainer width="90%" height={300} style={{ margin: '0 20px' }}>
                <BarChart
                    data={data}
                    layout="vertical"
                    margin={{ top: 24, right: 12, bottom: 8, left: 24 }}
                    barSize={100}
                    maxBarSize={120}
                    barCategoryGap={12}
                    barGap={4}
                    isAnimationActive={false}
                    className="custom-chart-overlay"
                >
                    <CartesianGrid strokeA="3 3" vertical horizontal={false} />
                    <Legend
                        verticalAlign="top"
                        align="center"
                        iconType="circle"
                        iconSize={10}
                        wrapperStyle={{ paddingBottom: 8 }}
                    />
                    <XAxis
                        type="number"
                        dataKey="value"
                        tick={{ fill: "#61677E", fontSize: 12 }}
                        tickMargin={6}
                        axisLine={false}
                        tickLine={false}
                    />
                    <YAxis
                        type="category"
                        dataKey="name"
                        width={80}
                        tick={{ fill: "#61677E", fontSize: 12 }}
                        axisLine={false}
                        tickLine={false}
                        tickMargin={28}
                        //angle={-45}
                        textAnchor="end"
                    />
                    <Tooltip cursor={{ fill: "rgba(0,0,0,0.06)" }} />
                    <Bar
                        name="Domains"
                        dataKey="value"
                        fill={color || "#fb742b"}
                        barSize={90}
                        radius={[0, 10, 10, 0]}
                        fillOpacity={1}
                        activeBar={{ style: { fillOpacity: 0.8 } }}
                    >
                        <LabelList 
                            dataKey="value" 
                            position="insideRight" 
                            formatter={(value) => `${value}%`}
                            fill="#000"
                            fontSize={12}
                            fontWeight={600}
                            stroke="#000"
                            strokeWidth={0.3}
                        />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </ChartWrap>
    );
}, (prevProps, nextProps) => {
    if (!prevProps.data || !nextProps.data) return prevProps.data === nextProps.data;
    if (prevProps.data.length !== nextProps.data.length) return false;
    return prevProps.data.every((item, index) => {
        const nextItem = nextProps.data[index];
        return item.name === nextItem.name && item.value === nextItem.value;
    });
});

DomainsPerformanceChart.displayName = 'DomainsPerformanceChart';

const config = {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        marginTop: 0,
        spacingLeft: 0,
        spacingRight: 0,
        spacingTop: 0,
        height: 120,
        width: 120,
        animation: true,
        backgroundColor: "transparent",
    },
    title: {
        text: "0",
        align: "center",
        verticalAlign: "middle",
        y: 15,
        style: {
            fontWeight: 200,
            fontSize: "14px",
        },
    },
    tooltip: {
        enabled: false,
        formatter: function () {
            return `${this.key ?? ""}` + ":" + this.y + "";
        }
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            cursor: "pointer",
            dataLabels: {
                enabled: false,
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '110%',
            showInLegend: false,
            borderWidth: 0,
            colors: ["rgb(90,177,208)", COLOR.gray100],
        }
    },
    series: [{
        type: 'pie',
        name: '',
        innerSize: '50%',
        data: [
            ['', 0],
            ['', 100],
        ]
    }]
};

const chartColors = ["rgb(90,177,208)", COLOR.gray100];
const chartConfig = {
    height: 90,
    width: 70,
    innerRadius: '50%',
    outerRadius: '90%',
    startAngle: 180,
    endAngle: 0,
    titleStyle: {
        fontWeight: 400,
        fontSize: "11px",
    }
};



//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------



const OverflowTwo = styled.div`
    height: auto;
    overflow-x: auto;
    width: 70%;
    display: inline-block;
    border-right:1px solid black;
    @media (max-width: 634px) {
        width: 50%;
    }
`;

const OverflowGradeTable = styled.div`
    height: auto;
    overflow-x: auto;
    width: 100%;
    display: inline-block;
    @media (max-width: 634px) {
        width: 50%;
    }
`;

const AssignmentDeleteWrapper = styled.div`
   cursor:pointer;
   margin-top: 5px;
   opacity:0;
`;


const OneLogoRow = styled.div`
  display: flex;
  flex-direction: row;
`;
const TableHeader = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0px 8px 4px 8px;
    margin-bottom: 4px;
`;




const Wrapper = styled.div`
    width: 100%;
`;
const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
`;
const TbgImgWrapper = styled.div`
    height: 69px;
    width: 100%;
    display: flex;
    justify-content: center;
`

const Tab = styled.button`
    border: none;
    background-image: ${p => p.bgColor ? `linear-gradient(to right, ${p.bgColor} , ${p.bgColor})` : getBgColor(p.active)};
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px 0px;
    text-transform: uppercase;
    width: 150px;
    color: white;
    margin-right: 8px;
    border-radius: 3px;
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    width: 100%;
`;

const OverviewIcon = styled.div`
    width: 20px;
    height: 20px;
    object-fit: cover;
    object-position: center;
    margin-left: -2.4px;
    margin-top: -2.5px;
    background-image: url(${p => p.src});
    background-position: center;
    background-size: 2880% 288%;
    background-repeat: no-repeat;
}
    `

const Logo = styled.img`
  width: 60px;
  border-radius: 50%;
`;
const OneWayText = styled.span`
  color: #424447;
  font-size: 16px;
  font-weight: 500;
  margin-left: 10px;
  text-transform: uppercase;
  line-height: 20px;
`;

const AssignmentTxt = styled.div`
    font-size: 14px;
    font-weight: 600;
`;
const NameContent = styled.span`
    color: #fff;
    margin-left: 10px;
    width: 220px;
    font-size:20px;
    font-weight: 700;


`;
const StudentNameTable = styled.div`
    display: flex;
    flex-direction: column;
    width: 230px;
    height: 40px;
    padding-right: 20px;
    padding-top: 2px;
    padding-bottom: 2px;
    justify-content: center;
    `;
const QuestionTab = styled.span`
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    background-color: #6ca642;
    width: 95%;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
    box-sizing: border-box;
`;
const StudentName = styled.span`
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    background-color: #5271ff;
    width: 95%;
    height: 40px;
    padding-left: 10px;
    padding-top: 5px;
    padding-right: 10px;
    border-radius: 5px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    min-width: 0;
`;
const StudentNameText = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
`;
const HeaderTab = styled.div`
    height:25px;
    border:1px solid white;
    border-radious:5px;
    background-color:${COLOR.indigo100};
    color: white;
    text-align: center;
    margin-top: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:0px 5px;
    padding: 3px 5px;
    display:flex;
    overflow: hidden;
`;
const HeaderTabP = styled.div`
    height:32px;
    border:1px solid white;
    border-radious:5px;
    background-color:rgb(11,9,84);
    color: white;
    text-align: center;
    margin-top: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    padding: 3px 5px;
    display:flex;
    overflow: hidden;
`;
const TableTopBtnCont = styled.div`
    justify-content: center;
    align-items: center;
    padding-left: 1.5%;
    overflow: hidden;
    display: flex;
    padding-left:5px;
    padding-right:5px;
`;
const TopTabCont = styled.div`
    display:flex;
    flex-direction:row;
`;
const TotalNStudentTxt = styled.span`
    font-size: 14px;
    font-weight: 600;
    margin-left: 10px;
    margin-top: 10px;
    // white-space:pre-line;
    `;
const Exam2TableHeader = styled(TableHeader)`
    background-color:rgb(54,58,78);
    height:60px;
    border-radius:5px;
    align-items:center;
 

`;
const ChartContainer = styled.div`
    display:flex;
    flex-direction:row;
    width:100%;
    flex-wrap:wrap;
    @media (max-width: 992px) {
       width:100%;
      }
    
`;
const ChartContainerInner = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    height:50px;
    margin-left:10px;
    margin-right:10px;
`;
const ChartLabel = styled.span`
    font-size: 15px;
    font-weight: 600;
    margin-bottom: -20px;
`;
const SearchBox = styled.input`
  background-color: transparent;
  border: none;
  border-radius: 7px;
  color: white;
  font-size: 14px;
  font-weight: 400;
  height: 30px;
  outline: none;
  padding: 2px 16px;
  width: 90%;
  margin-right: 2px;
  margin-left: 2px;
  &::placeholder {
    color: #fff;
  }
  &::-webkit-input-placeholder {
    color: #fff;
  }
  &:-ms-input-placeholder {
    color: #fff;
  }
  @media (max-width: 992px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
const SearchBoxContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 5px;
    background-color:rgb(126,112,165);
    color: ${COLOR.green};
    font-size: 14px;
    align-items: center;
    width:100%;
    padding-right:12px;
    height: 40px;
    max-width: 200px;
    @media (max-width: 1440px) {
       min-width:200px;
       margin-bottom:30px;
      }
`;
const ExamTableSection1 = styled.div`
    display: flex;
    flex-direction: column;
    width: 230px;
    justify-content: space-between;
    `;
const ExamTableSection2 = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media (max-width: 992px) {
        width: 100%;
    }
    `;
const TableItem = styled.td`
    height: 40px;
    width: 25%;
    border: 0.1px solid rgba(0,0,0,0.2);
    border-collapse: collapse;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-sizing: border-box;
    position: relative;
    `;
const ExamGradeTable = styled.table`
  border-collapse: collapse;
`;
const ExamGradeBoday = styled.tbody`
`;
const ExamRow = styled.tr`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const PlacementText = styled.span`
       color:${p => p.textColor ? p.textColor : COLOR.gray100}
    `;
const GraphRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    // justify-content: space-between;
    margin-top:20px;
   @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    }

`;
const ExamOverflowTwo = styled(OverflowTwo)`
    width:100%;
    border-right: 0px;
    @media (max-width: 992px) {
        width:100%;
    }
    `;
const CloseBtn = styled.span`
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-left: 10px;
    margin-top: 10px;
    align-self: flex-end;
    display:flex;
    flex-direction:row;
    color:rgb(197,2,91);
    font-weight:bold;
    justify-content: flex-end;
    `;
const ExamGradeSec = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-image:url(${TableBg});
    padding:16px;
    margin-bottom:60px;
`;


const ExamButton = styled.button`
     background-color:${COLOR.blueishdeep};
     background-image: ${p => !p.active ? COLOR.blueishdeep : getBgColor(p.active)};
     width:120px;
     height:30px;
     border-radius:5px;
     margin-left:5px;
     margin-right:5px;
     border: 1px solid ${p => p.active ? "#f6ebeb" : "transparent"};
     cursor: pointer;
     box-sizing: border-box;
      margin-bottom: 3px;
     box-shadow:${p => p.active ? "2px 2px 2px rgb(35 53 89 / 19%), -2px -2px 2px rgb(35 53 89 / 19%)" : "none"};
     color:rgb(255,255,255);
     @media (max-width: 590px) {
       width:100% !important;
       margin-left:0px !important;
       margin-right:0px !important;
       margin-bottom: 6px;
     }
}
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;

const getWidth = (index) => {
    const minSize = 110
    let txt = ACIFL_LEVEL[index]
    if (!txt) return minSize + 50
    return txt.length * 2 + minSize + 10

}

const getColumnWidthStyle = (index) => {
    const width = index === 0 ? PLACEMENT_COLUMN_WIDTH : getWidth(index - 1);
    return { width, minWidth: width, flexShrink: 0 };
};

const getCombinedSubCellStyle = (columnIndex) => {
    const groupWidth = columnIndex === 0 ? PLACEMENT_COLUMN_WIDTH : getWidth(columnIndex - 1);
    const subWidth = groupWidth / 3;
    return { width: subWidth, minWidth: subWidth, flexShrink: 0 };
};

const renderCenteredCellValue = (value) => (
    <CellCenter>{value ?? null}</CellCenter>
);
const getPlacemEntColor = (v) => {
    if (v == ACIFL_LEVEL[2] || v == ACIFL_LEVEL_ABBR[2]) {
        return PLACEMNETCOLOR[0]
    } else if (v == ACIFL_LEVEL[3] || v == ACIFL_LEVEL_ABBR[3]) {
        return PLACEMNETCOLOR[1]
    } else if (v == ACIFL_LEVEL[4] || v == ACIFL_LEVEL_ABBR[4]) {
        return PLACEMNETCOLOR[2]
    } else if (v == ACIFL_LEVEL[5] || v == ACIFL_LEVEL_ABBR[5]) {
        return PLACEMNETCOLOR[3]
    } else if (v == ACIFL_LEVEL[6] || v == ACIFL_LEVEL_ABBR[6]) {
        return PLACEMNETCOLOR[4]
    } else if (v == ACIFL_LEVEL[7] || v == ACIFL_LEVEL_ABBR[7]) {
        return PLACEMNETCOLOR[5]
    } else if (v == ACIFL_LEVEL[8] || v == ACIFL_LEVEL_ABBR[8]) {
        return PLACEMNETCOLOR[7]
    } else if (v == 'NOT FINISHED' || v == 'NF') {
        return COLOR.yellow
    }
    else {
        return COLOR.gray100;
    }
}

const ExamTableHeader = ({EXAM_LABELS, EXAM_LABELS_FULL}) => {
    return (
        <div style={{ display: "flex", flexDirection: "row" }}>
    <ExamGradeTable>
        <ExamGradeBoday>
            <Exam2TableHeader>
                <ExamTableSection1 style={{ width: 220 }}>
                    <NameContent>Name</NameContent>
                </ExamTableSection1>
                <ExamTableSection2>
                    <TopTabCont>
                        <TableTopBtnCont style={{ width: 140 }}>
                            <HeaderTabP style={{ fontSize: 15, width: "90%", fontWeight: 600, borderRadius: '10px' }}>Placement</HeaderTabP>
                        </TableTopBtnCont>
                        {EXAM_LABELS && EXAM_LABELS.length > 0 && map(EXAM_LABELS, (key, index) => (<TableTopBtnCont key={key + index} style={{ width: getWidth(index) }}>
                            <TootipWrapper hasToolTip label={EXAM_LABELS_FULL[index]}>
                                <HeaderTab key={key} style={{ fontSize: 12, textOverflow: "ellipsis", width: "90%", borderRadius:'10px' }}>{key}</HeaderTab>
                            </TootipWrapper>
                        </TableTopBtnCont>
                        ))}
                    </TopTabCont>
                </ExamTableSection2>
            </Exam2TableHeader>
        </ExamGradeBoday>
    </ExamGradeTable>
    </div>
    )

}

const ViewGradeTable = ({ filteredusers_response, question_length, toggleModal, toggleFlagModal, openFlagModal, EXAM_LABELS, EXAM_LABELS_FULL, onViewSubmission }) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    useEffect(()=>{
        setPage(0)
    },[filteredusers_response])
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    const checkMark = (submissions) => {
        if (!submissions.includes("-")) {
            return <TootipWrapper hasToolTip label={`Completed`}>
                <Check style={{ backgroundColor: COLOR.greentrue, color: COLOR.white, fontSize: 12, borderRadius: "50%" }} />
            </TootipWrapper>
        } else if (containsNumber(submissions)) {
            return <TootipWrapper hasToolTip label={`Not finished`}>
                <Check style={{ backgroundColor: COLOR.orange100, color: COLOR.white, fontSize: 12, borderRadius: "50%" }} />
            </TootipWrapper>
        } else {
            return null;
        }
    }
    // data.grades.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) 
    return (<>

        <OverflowGradeTable >
        {/* ViewGrade Header */}
        {ExamTableHeader({EXAM_LABELS, EXAM_LABELS_FULL})}
        {/* ViewGrade Body */}
        <ExamGradeBoday style={{ display: "flex", flexDirection: "column", marginTop: -3 }}>
            <GradeTableRow>
                <ExamTableSection1>
                    <StudentNameTable>
                        <QuestionTab>Questions per section:</QuestionTab>
                    </StudentNameTable>
                    <StudentNameTable>
                        <QuestionTab>Max points possible:</QuestionTab>
                    </StudentNameTable>
                </ExamTableSection1>
                <ExamTableSection2>
                    <ExamGradeTable borderd>
                        <ExamRow>
                            {question_length.map((k, i) => (
                                <TableItem key={`q_len_${i}`} style={getColumnWidthStyle(i)}>
                                    {i === 0 ? null : renderCenteredCellValue(k)}
                                </TableItem>
                            ))}
                        </ExamRow>
                        <ExamRow>
                            {SECTION_MAX_POINTS.map((k, i) => (
                                <TableItem key={`max_pts_${i}`} style={getColumnWidthStyle(i)}>
                                    {i === 0 ? null : renderCenteredCellValue(k)}
                                </TableItem>
                            ))}
                        </ExamRow>
                    </ExamGradeTable>
                </ExamTableSection2>
            </GradeTableRow>
            <FlatList
                list={filteredusers_response.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                renderItem={({ user, submissions, assignment_details }, i) => (
                    <GradeTableRow key={`${user?.id || i}_grade_row`}>
                        <ExamTableSection1>
                            <StudentNameTable>
                                <TootipWrapper hasToolTip label={`${user.firstName} , ${user.lastName}`}>
                                    <StudentName>
                                        <StudentNameText>{user.firstName} , {user.lastName}</StudentNameText>
                                        <RemoveRedEyeIcon sx={{ color: 'black', cursor: 'pointer' }} onClick={() => toggleModal(user)} />
                                    </StudentName>
                                </TootipWrapper>
                            </StudentNameTable>
                        </ExamTableSection1>
                        <ExamTableSection2>
                            <ExamGradeTable borderd>
                                <ExamRow>
                                    {map(submissions, (k, ind) => {
                                        const sectionDetail = ind > 0 ? assignment_details?.[ind - 1] : null;
                                        return (
                                            <TableItem key={`${user?.id || i}_col_${ind}`} style={getColumnWidthStyle(ind)}>
                                                {ind === 0
                                                    ? renderPlacementCell(k, submissions, checkMark)
                                                    : renderGradeCell(k, sectionDetail?.assignment_id, user, onViewSubmission)}
                                            </TableItem>
                                        );
                                    })}
                                </ExamRow>
                            </ExamGradeTable>
                        </ExamTableSection2>
                    </GradeTableRow>
                )}
                renderWhenEmpty={() => <div></div>}
            />




        </ExamGradeBoday>
        </OverflowGradeTable>
        {
                openFlagModal &&
                    createPortal(
                        <div
                            style={{
                                position: 'fixed',
                                inset: 0,
                                zIndex: 1300,
                                pointerEvents: 'none',
                            }}
                        >
                            <Rnd
                                key="district-report-flag-rnd"
                                default={getDistrictFlagModalRndDefaults()}
                                bounds="window"
                                enableResizing={false}
                                dragHandleClassName="district-flag-drag-panel"
                                cancel=".district-flag-modal-close,.district-flag-modal-close *"
                                style={{ pointerEvents: 'auto', zIndex: 1301 }}
                            >
                                <div style={{ position: 'relative' }}>
                                    <div
                                        className="flatModalWidth district-flag-drag-panel"
                                        style={{ position: 'relative', boxSizing: 'border-box', cursor: 'move' }}
                                    >
                                        <div
                                            className="district-flag-modal-close"
                                            style={{
                                                position: 'absolute',
                                                top: 8,
                                                right: 8,
                                                zIndex: 10,
                                                cursor: 'pointer',
                                                backgroundColor: 'red',
                                                borderRadius: '100%',
                                                width: 24,
                                                height: 24,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <CloseIcon
                                                onTouchStart={(e) => e.stopPropagation()}
                                                onClick={toggleFlagModal}
                                                style={{ width: 20, height: 20, color: 'white' }}
                                            />
                                        </div>
                                        <p style={{ fontSize: '20px', fontWeight: '600', color: '#fff', margin: '0px', paddingRight: 32 }}>
                                            Flag System
                                        </p>
                                        <ul>
                                            {flagData.map((item, index) => {
                                                return (
                                                    <li key={index} style={{ margin: 0, color: '#fff', fontSize: 14, fontWeight: 600, marginLeft: '20px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <span style={{ width: 18, height: 18, borderRadius: 3, background: item.backgroundcolor }} />
                                                            <span style={{ flex: 1 }}>{item.title}</span>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </Rnd>
                        </div>,
                        document.body,
                    )
            }
        <TablePagination
            count={filteredusers_response.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[50, 100, 150, 200 , 300, 400 , 500]}
            style={{   float: "right" }}
            backIconButtonProps={{
                color: "secondary"
            }}
            nextIconButtonProps={{ color: "secondary" }}
        />
    </>)
}
const ViewGradeTableCombine = ({ filteredusers_response, question_length, toggleModal, modal, toggleFlagModal, openFlagModal, studentData, loading, examType, EXAM_LABELS, EXAM_LABELS_FULL, onViewSubmission }) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }
    useEffect(()=>{
        setPage(0)
    },[filteredusers_response])
    // data.grades.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) 
    return (<>

        <OverflowGradeTable >
        {/* ViewGrade Combine Header     */}
        {ExamTableHeader({EXAM_LABELS, EXAM_LABELS_FULL})}
        {/* ViewGrade Combine Body */}
        <ExamGradeBoday style={{ display: "flex", flexDirection: "column", marginTop: -3 }}>
            <GradeTableRow>
                <ExamTableSection1>
                    <StudentNameTable>
                        <QuestionTab style={{ backgroundColor: COLOR.indigo200, justifyContent: 'center' }}>Exams</QuestionTab>
                    </StudentNameTable>
                    <StudentNameTable>
                        <QuestionTab>Questions per section:</QuestionTab>
                    </StudentNameTable>
                </ExamTableSection1>
                <ExamTableSection2>
                    <ExamGradeTable borderd>
                        <ExamRow>
                            {map(['', ...EXAM_LABELS], (k, i) => (
                                <CombinedColumnGroup key={`exam_hdr_${k}${i}`} style={{ ...getColumnWidthStyle(i), backgroundColor: COLOR.indigo400, color: '#fff' }}>
                                    <CombinedCellRow>
                                        <TableItem style={{ ...getCombinedSubCellStyle(i), fontSize: '12px', fontWeight: '600' }}>
                                            {renderCenteredCellValue('E1')}
                                        </TableItem>
                                        <TableItem style={{ ...getCombinedSubCellStyle(i), fontSize: '12px', fontWeight: '600' }}>
                                            {renderCenteredCellValue('E2')}
                                        </TableItem>
                                        <TableItem style={{ ...getCombinedSubCellStyle(i), fontSize: '12px', fontWeight: '600' }}>
                                            {renderCenteredCellValue('E3')}
                                        </TableItem>
                                    </CombinedCellRow>
                                </CombinedColumnGroup>
                            ))}
                        </ExamRow>
                        <ExamRow>
                            {question_length.map(({ exam1, exam2, exam3 }, i) => (
                                <CombinedColumnGroup key={`q_len_combine_${i}`} style={getColumnWidthStyle(i)} $striped={i % 2 !== 0}>
                                    <CombinedCellRow>
                                        <TableItem style={getCombinedSubCellStyle(i)}>
                                            {i === 0 ? null : renderCenteredCellValue(exam1)}
                                        </TableItem>
                                        <TableItem style={getCombinedSubCellStyle(i)}>
                                            {i === 0 ? null : renderCenteredCellValue(exam2)}
                                        </TableItem>
                                        <TableItem style={getCombinedSubCellStyle(i)}>
                                            {i === 0 ? null : renderCenteredCellValue(exam3)}
                                        </TableItem>
                                    </CombinedCellRow>
                                </CombinedColumnGroup>
                            ))}
                        </ExamRow>
                    </ExamGradeTable>
                </ExamTableSection2>
            </GradeTableRow>
            {
                openFlagModal && (
                    <div style={{position:'absolute', bottom:'20%', left:'10%', zIndex:1000}}>
                  <div onTouchStart={toggleFlagModal}  onClick={toggleFlagModal} style={{position:'absolute', top:8, right:8, zIndex:10, cursor:'pointer', backgroundColor:'red', borderRadius:'100%', width:24, height:24, display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <CloseIcon  style={{width: 20, height: 20, color: "white"}} />
                  </div>
                  <div className='flatModalWidth'>
                    <p style={{fontSize:'20px', fontWeight:'600', color:'#fff', margin:'0px'}}>Flag System</p>
                    <ul>
                      {
                        flagData.map((item,index) => {
                          return (
                            <li style={{ margin: 0, color: '#fff', fontSize: 14, fontWeight: 600, marginLeft:'20px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ width: 18, height: 18, borderRadius: 3, background: item.backgroundcolor }} />
                                <span style={{ flex: 1 }}>
                                  {item.title}
                                </span>
                              </div>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                </div>

                )
            }
                            
            <FlatList
                list={filteredusers_response.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                renderItem={({ user, submissions, assignment_details_by_exam }, rowIndex) => (
                    <GradeTableRow key={`${user?.id || rowIndex}_combine_row`}>
                        <ExamTableSection1>
                            <StudentNameTable>
                                <TootipWrapper hasToolTip label={`${user.firstName} , ${user.lastName}`}>
                                    <StudentName>
                                        <StudentNameText>{user.firstName} , {user.lastName}</StudentNameText>
                                        <RemoveRedEyeIcon sx={{ color: 'black', cursor: 'pointer' }} onClick={() => toggleModal(user)} />
                                    </StudentName>
                                </TootipWrapper>
                            </StudentNameTable>
                        </ExamTableSection1>
                        <ExamTableSection2>
                            <ExamGradeTable borderd>
                                <ExamRow>
                                    {map(submissions, ({ exam1, exam2, exam3 }, colIndex) => {
                                        const sectionIndex = colIndex > 0 ? colIndex - 1 : -1;
                                        const exam1Detail = sectionIndex >= 0 ? assignment_details_by_exam?.exam1?.[sectionIndex] : null;
                                        const exam2Detail = sectionIndex >= 0 ? assignment_details_by_exam?.exam2?.[sectionIndex] : null;
                                        const exam3Detail = sectionIndex >= 0 ? assignment_details_by_exam?.exam3?.[sectionIndex] : null;
                                        return (
                                            <CombinedColumnGroup
                                                key={`${user?.id || rowIndex}_col_${colIndex}`}
                                                style={getColumnWidthStyle(colIndex)}
                                                $striped={colIndex % 2 !== 0}
                                            >
                                                {colIndex === 0 ? (
                                                    <CombinedCellRow>
                                                        <TableItem style={getCombinedSubCellStyle(colIndex)}>
                                                            <PlacementCellContent>
                                                                <PlacementText textColor={getPlacemEntColor(exam1)}>{exam1}</PlacementText>
                                                            </PlacementCellContent>
                                                        </TableItem>
                                                        <TableItem style={getCombinedSubCellStyle(colIndex)}>
                                                            <PlacementCellContent>
                                                                <PlacementText textColor={getPlacemEntColor(exam2)}>{exam2}</PlacementText>
                                                            </PlacementCellContent>
                                                        </TableItem>
                                                        <TableItem style={getCombinedSubCellStyle(colIndex)}>
                                                            <PlacementCellContent>
                                                                <PlacementText textColor={getPlacemEntColor(exam3)}>{exam3}</PlacementText>
                                                            </PlacementCellContent>
                                                        </TableItem>
                                                    </CombinedCellRow>
                                                ) : (
                                                    <CombinedCellRow>
                                                        <TableItem style={getCombinedSubCellStyle(colIndex)}>
                                                            {renderGradeCell(exam1, exam1Detail?.assignment_id, user, onViewSubmission)}
                                                        </TableItem>
                                                        <TableItem style={getCombinedSubCellStyle(colIndex)}>
                                                            {renderGradeCell(exam2, exam2Detail?.assignment_id, user, onViewSubmission)}
                                                        </TableItem>
                                                        <TableItem style={getCombinedSubCellStyle(colIndex)}>
                                                            {renderGradeCell(exam3, exam3Detail?.assignment_id, user, onViewSubmission)}
                                                        </TableItem>
                                                    </CombinedCellRow>
                                                )}
                                            </CombinedColumnGroup>
                                        );
                                    })}
                                </ExamRow>
                            </ExamGradeTable>
                        </ExamTableSection2>
                    </GradeTableRow>
                )}
                renderWhenEmpty={() => <div>No Story Articles</div>}
            />




        </ExamGradeBoday>
        </OverflowGradeTable>
        
        <TablePagination
            count={filteredusers_response.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[50, 100, 150, 200 , 300, 400 , 500]}
            style={{   float: "right" }}
            backIconButtonProps={{
                color: "secondary"
            }}
            nextIconButtonProps={{ color: "secondary" }}
        />
    </>)
}
const ExamTable = ({
    dataLoading,
    examType,
    resultData,
    resultDataCombine,
    activeSession,
    schoolType,
}) => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const booksAllList = useAllBook();
    const showAlert = useAlert();
    const isCombined = examType === "combined"
    const [assignmentDrawer, toggleAssignmentDrawer] = useState(false);
    const [assignmentData, setAssignmentData] = useState({});
    const [selectedAssignmentUserSubmission, setSelectedAssignmentSubmissions] = useState([]);
    const [assignmentReviewLoading, setAssignmentReviewLoading] = useState(false);
    const [pendingReviewData, setPendingReviewData] = useState(null);
    const [districtReviewClass, setDistrictReviewClass] = useState({});

    const activeGradesSingle = useMemo(
        () => filterDistrictProficiencyGradesByActiveUser(resultData?.grades),
        [resultData],
    );
    const activeGradesCombine = useMemo(
        () => filterDistrictProficiencyGradesByActiveUser(resultDataCombine?.grades),
        [resultDataCombine],
    );

    const [filteredusers_response, setUserResponse] = useState(() => activeGradesSingle);
    const [filteredusers_response_combine, setUserResponseCpmbine] = useState(() => activeGradesCombine);

    useEffect(() => {
        setUserResponse(activeGradesSingle);
    }, [activeGradesSingle]);
    useEffect(() => {
        setUserResponseCpmbine(activeGradesCombine);
    }, [activeGradesCombine]);

    const [modal, setModal] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [selectedClassId, setSelectedClassId] = useState(null);
    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(false);

    const processPendingReviewData = useCallback((pendingData) => {
        if (!pendingData) return null;
        const { data, users, userSubmissions } = pendingData;
        const focalUserId = data?.userId;
        const processedUsers = map(users, (usr) => {
            if (!usr?.id) return null;
            const pool = userSubmissions[usr.id] || [];
            const sub = Array.isArray(pool) ? pool[0] : pool;
            if (sub) return { ...sub, disableEdit: true };
            return null;
        }).filter(Boolean);
        let processedData =
            find(processedUsers, (u) => u.userId === focalUserId && !u.isTemp)
            || find(processedUsers, (u) => u.userId === focalUserId)
            || data;
        if (processedData) {
            processedData = { ...processedData, disableEdit: true };
        }
        return { processedData, processedUsers };
    }, []);

    useEffect(() => {
        if (!assignmentDrawer || !pendingReviewData) return;
        requestAnimationFrame(() => {
            const processedResult = processPendingReviewData(pendingReviewData);
            if (!processedResult) return;
            setSelectedAssignmentSubmissions(processedResult.processedUsers);
            setAssignmentData(processedResult.processedData);
            const classId = processedResult.processedData?.classId;
            setDistrictReviewClass(classId ? { id: classId } : {});
        });
    }, [assignmentDrawer, pendingReviewData, processPendingReviewData]);

    const closeAssignmentDrawer = useCallback(() => {
        toggleAssignmentDrawer(false);
        setPendingReviewData(null);
        setAssignmentData({});
        setSelectedAssignmentSubmissions([]);
        setDistrictReviewClass({});
    }, []);

    const isAssignmentReviewReady = useMemo(() => {
        if (!assignmentDrawer) return false;
        if (!assignmentData?.assignmentId) return false;
        return Array.isArray(selectedAssignmentUserSubmission) && selectedAssignmentUserSubmission.length > 0;
    }, [assignmentDrawer, assignmentData, selectedAssignmentUserSubmission]);

    const reviewDistrictAssignment = useCallback(async (user, assignmentId, classId) => {
        if (!user?.id || !assignmentId || !classId) return;
        try {
            setAssignmentReviewLoading(true);
            toggleAssignmentDrawer(true);
            setPendingReviewData(null);
            setAssignmentData({});
            setSelectedAssignmentSubmissions([]);
            setDistrictReviewClass({ id: classId });
            const submissionsResult = await dispatch(handleListSubmissionsByAssignmentAndClass(assignmentId, classId));
            const apiSubmissions = Array.isArray(submissionsResult) ? submissionsResult : [];
            const focalSubmission = find(apiSubmissions, { userId: user.id });
            if (!focalSubmission) {
                toggleAssignmentDrawer(false);
                setDistrictReviewClass({});
                return;
            }
            const apiUserSubmissions = groupBy(apiSubmissions, 'userId');
            const usersList = uniqBy(
                apiSubmissions.map((s) => s.user).filter(Boolean),
                'id'
            );
            setPendingReviewData({
                data: focalSubmission,
                users: usersList,
                userSubmissions: apiUserSubmissions,
            });
        } catch (error) {
            Sentry.captureException(`district review assignment: ${error}`);
            toggleAssignmentDrawer(false);
            setPendingReviewData(null);
            setAssignmentData({});
            setSelectedAssignmentSubmissions([]);
            setDistrictReviewClass({});
        } finally {
            setAssignmentReviewLoading(false);
        }
    }, [dispatch]);
    
    const toggleModal = (student = null) => {
        if (student) {
            setSelectedStudent(student);
            setSelectedClassId(student.class_id || student.classId || null);
        }
        setModal(!modal);
        if (!modal && student) {
            setStudentData(null);
        }
    }


    const [openFlagModal, setOpenFlagModal] = useState(false);
    const toggleFlagModal = () => {
        setOpenFlagModal(!openFlagModal);
    }

    const getPriorityColor = (performance) => {
        if (performance >= 80) return '#078247';
        if (performance >= 60) return '#7b13c3';
        return '#df0d14';
    };

    const getPriorityText = (performance) => {
        if (performance >= 80) return 'On Track';
        if (performance >= 60) return 'Needs Attention';
        return 'Urgent Support Needed';
    };

    const domainsChartData = useMemo(() => {
        if (studentData?.domains && studentData.domains.length > 0) {
            return studentData.domains;
        }
        return domainData;
    }, [studentData?.domains]);

    const printRef = useRef();
    const [printLoader, setPrintLoader] = useState(false);
    const isTablate = useTabletDetection();
    const isMobile = useMobileDetect() && !isTablate;
    const isLandscape = useOrientation();

    const printCall = useReactToPrint({
        contentRef: printRef,
        onBeforeGetContent: async () => {
            return new Promise((resolve) => {
                setPrintLoader(true);
                setTimeout(() => resolve(), 100);
            });
        },
        onBeforePrint: async () => {
            setPrintLoader(true);
        },
        onAfterPrint: async () => {
            setPrintLoader(false);
            removePrintableClass();
        },
        onPrintError: async () => {
            setPrintLoader(false);
            removePrintableClass();
        },
    });

    const handlePrint = () => {
        if (isMobile || isTablate) {
            showAlert("Print is not supported on this device!", "error");
            return;
        }
        setPrintLoader(true);
        addPrintableClass();
        setTimeout(() => {
            printCall();
        }, 100);
    };

    useEffect(() => {
        const loadStudentData = async () => {
            if (!modal || !selectedStudent || !activeSession || !currentUser?.orgId || !examType || examType === 'combined') return;
            
            const examNumber = examType === 'exam1' ? '1' : examType === 'exam2' ? '2' : examType === 'exam3' ? '3' : null;
            if (!examNumber) return;

            setLoading(true);
            try {
                const res = await dispatch(handleGetStudentSubmissionDetailsProficiency(
                    selectedStudent.id,
                    activeSession,
                    currentUser.orgId,
                    examNumber,
                    selectedClassId,
                    schoolType
                ));
                if (res?.success && res?.data) {
                    setStudentData(res.data);
                }
            } catch (error) {
                console.error('Error loading student data:', error);
            } finally {
                setLoading(false);
            }
        };
        loadStudentData();
    }, [modal, selectedStudent, selectedClassId, activeSession, currentUser?.orgId, examType, schoolType, dispatch]);

    const filterStudent = (e) => {
        let value = e.target.value?.toLowerCase();
        if (!isCombined) {
            if (value && value.length > 0) {
                let st = filter(activeGradesSingle, ({ user }) => {
                    return (user?.username?.toLowerCase()?.includes(value?.toLowerCase()) || user?.firstName?.toLowerCase()?.includes(value?.toLowerCase()) || user?.lastName?.toLowerCase()?.includes(value?.toLowerCase()))
                })
                setUserResponse(st)
            } else {
                setUserResponse(activeGradesSingle)
            }
        } else {
            if (value && value.length > 0) {
                let st = filter(activeGradesCombine, ({ user }) => {
                    return (user?.username?.toLowerCase()?.includes(value?.toLowerCase()) || user?.firstName?.toLowerCase()?.includes(value?.toLowerCase()) || user?.lastName?.toLowerCase()?.includes(value?.toLowerCase()))
                })
                setUserResponseCpmbine(st)
            } else {
                setUserResponseCpmbine(activeGradesCombine)
            }
        }

    }
    const chartDataMemo = useMemo(() => {
        const grades = isCombined ? activeGradesCombine : activeGradesSingle;
        if (!grades?.length) return null;

        const normalizeKey = (val) =>
            typeof val === "string" ? val.trim().replace(/\s+/g, " ") : val;

        const normalizedACIFL = ACIFL_LEVEL.map((l) => normalizeKey(l));
        const missingKey = normalizedACIFL[normalizedACIFL.length - 1];
        const levelKeys = normalizedACIFL.slice(0, -1);

        const abbrToLevel = ACIFL_LEVEL_ABBR.reduce((acc, abbr, idx) => {
            acc[normalizeKey(abbr)] = levelKeys[idx];
            return acc;
        }, {});

        const bestLevelForCombinedStudent = ({ exam1, exam2, exam3 } = {}) => {
            const exams = [exam1, exam2, exam3];
            const mappedLevels = exams
                .map((v) => abbrToLevel[normalizeKey(v)])
                .filter(Boolean);

            for (let i = 0; i < levelKeys.length; i++) {
                if (mappedLevels.includes(levelKeys[i])) return levelKeys[i];
            }
            return missingKey;
        };

        const groupKey = (item) => {
            if (!isCombined) return normalizeKey(item?.submissions?.[0]);
            const bucketValue = bestLevelForCombinedStudent(item?.submissions?.[0] || {});
            return bucketValue;
        };

        const groupdata = groupBy(grades, groupKey);
        const totalStudent = grades.length;

        const notAssigned = get(groupdata[normalizeKey("NOT ASSIGNED")], "length", 0);
        const notStarted = get(groupdata[normalizeKey("NOT STARTED")], "length", 0);
        const notFinished = get(groupdata[normalizeKey("NOT FINISHED")], "length", 0);

        let studentsInNamedProficiencyLevels = 0;
        levelKeys.forEach((level) => {
            studentsInNamedProficiencyLevels += get(groupdata[normalizeKey(level)], "length", 0);
        });
        const missingPlacementCount = Math.max(0, totalStudent - studentsInNamedProficiencyLevels);

        return {
            groupdata,
            totalStudent,
            notAssigned,
            notStarted,
            notFinished,
            missingKey,
            levelKeys,
            missingPlacementCount,
        };
    }, [activeGradesSingle, activeGradesCombine, isCombined]);

    const getChartConfig = (type, chartStats) => {
        if (!chartStats) {
            return [
                { name: type, value: 0, fill: chartColors[0] },
                { name: "", value: 100, fill: chartColors[1] },
            ];
        }

        const normalizeKey = (val) =>
            typeof val === "string" ? val.trim().replace(/\s+/g, " ") : val;

        const { groupdata, totalStudent, missingKey, missingPlacementCount } = chartStats;
        const typeKey = normalizeKey(type);
        let count = 0;
        
        if (typeKey === missingKey) {
            count = missingPlacementCount;
        } else {
            count = get(groupdata[typeKey], "length", 0);
        }
        
        const percentage = totalStudent > 0 ? Math.round((count / totalStudent) * 100) : 0;
        const remainingPercentage = 100 - percentage;
        const fillColor = typeKey === missingKey ? "rgb(197,2,91)" : chartColors[0];
        
        return [
            { name: type, value: percentage, fill: fillColor },
            { name: "", value: remainingPercentage, fill: chartColors[1] },
        ];
    };

    const Charts = useMemo(() => {
        if (!chartDataMemo) {
            return (<ChartContainer>
                {map(ACIFL_LEVEL, k => (
                    <ChartContainerInner key={k}>
                        <ChartLabel style={{ fontSize: 10, marginBottom: -10, color: ACIFL_LEVEL[ACIFL_LEVEL.length - 1] == k ? "rgb(197,2,91)" : COLOR.black }}>{k}</ChartLabel>
                        <div style={{ position: 'relative', width: chartConfig.width, height: chartConfig.height }}>
                            <ResponsiveContainer width={70} height={70}>
                                <PieChart width={chartConfig.width} height={chartConfig.height}>
                                    <Pie
                                        data={[{ name: k, value: 0, fill: chartColors[0] }, { name: "", value: 100, fill: chartColors[1] }]}
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={chartConfig.outerRadius}
                                        innerRadius={chartConfig.innerRadius}
                                        startAngle={chartConfig.startAngle}
                                        endAngle={chartConfig.endAngle}
                                        paddingAngle={0}
                                        dataKey="value"
                                        nameKey="name"
                                        label={false}
                                        cornerRadius={5}
                                    >
                                        <Cell fill={chartColors[0]} />
                                        <Cell fill={chartColors[1]} />
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                textAlign: 'center',
                                ...chartConfig.titleStyle
                            }}>
                                0%
                            </div>
                        </div>
                    </ChartContainerInner>
                ))}
            </ChartContainer>);
        }

        return (<ChartContainer>
            {map(ACIFL_LEVEL, k => {
                const chartData = getChartConfig(k, chartDataMemo);
                const percentage = chartData[0]?.value || 0;
                
                return (<ChartContainerInner key={k}>
                    <ChartLabel style={{ fontSize: 10, marginBottom: -10, color: ACIFL_LEVEL[ACIFL_LEVEL.length - 1] == k ? "rgb(197,2,91)" : COLOR.black }}>{k}</ChartLabel>
                    <div style={{ position: 'relative', width: chartConfig.width, height: chartConfig.height }}>
                        <ResponsiveContainer width={70} height={70}>
                            <PieChart width={chartConfig.width} height={chartConfig.height}>
                                <Pie
                                    data={chartData}
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={chartConfig.outerRadius}
                                    innerRadius={chartConfig.innerRadius}
                                    startAngle={chartConfig.startAngle}
                                    endAngle={chartConfig.endAngle}
                                    paddingAngle={0}
                                    dataKey="value"
                                    nameKey="name"
                                    label={false}
                                    cornerRadius={5}
                                >
                                    {chartData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.fill} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                            ...chartConfig.titleStyle
                        }}>
                            {percentage}%
                        </div>
                    </div>
                </ChartContainerInner>)
            })}
        </ChartContainer>)
    }, [chartDataMemo, isCombined])
    // {dataLoading ? (
    //     <Loading />
    // ) : (
    return (
    <SentryWrap>
        <SpinLoader dataloader={assignmentReviewLoading} />
        <Drawer
            height="100%"
            destroyOnHidden={false}
            onClose={closeAssignmentDrawer}
            placement="top"
            open={assignmentDrawer}
            key="district-assignment-review"
            className="student-review-new"
        >
            <React.Suspense fallback={<AssignmentReviewSkeleton />}>
                {!isAssignmentReviewReady ? (
                    <AssignmentReviewSkeleton />
                ) : (
                    <AssignmentReview
                        open={assignmentDrawer}
                        booksAllList={booksAllList}
                        data={assignmentData}
                        usersSubmissionData={selectedAssignmentUserSubmission}
                        currentClass={districtReviewClass}
                        handleClose={closeAssignmentDrawer}
                        scale_1_5={false}
                        gradebook_a_f={false}
                        showAlert={showAlert}
                    />
                )}
            </React.Suspense>
        </Drawer>
        <Wrapper>
            <ContentLoading isLoading={dataLoading} />
                <div>
                    {/* <ExamGradeSec> */}
                        {/* <OneLogoRow>
                            <Col sm={20} xs={24} className='cstmExamRow'>
                              
                              <div className='cstmExamRowleft cstmExamRowleftExm'>
                                <div><Logo src={LogoOnExam} /></div>
                                <div>
                                <OneWayText>
                                    {"ONE  WAY"}
                                    <AssignmentTxt> {"Assignments"}</AssignmentTxt>
                                </OneWayText>
                                <Dropdown menu={menuData()} placement="bottomLeft" trigger={['click']}>
                                    <Button onClick={e => e.preventDefault()}>
                                        {activeSession ? activeSession : 'sessions'}
                                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                    </Button>
                                </Dropdown>
                                </div>
                               </div>

                               <div className='cstmExamRowRight'>
                                <ExamButton
                                    active={examType === "exam1"}
                                    onClick={() => {
                                        onExamTabClick("exam1");
                                    }}
                                >
                                    Exam1
                                </ExamButton>
                                <ExamButton
                                    active={examType === "exam2"}
                                    onClick={() => {
                                        onExamTabClick("exam2");
                                    }}
                                >
                                    Exam2
                                </ExamButton>
                                <ExamButton
                                    active={examType === "exam3"}
                                    onClick={() => {
                                        onExamTabClick("exam3");
                                    }}
                                >
                                    Exam3
                                </ExamButton>
                                <ExamButton
                                    active={examType == "combined"}
                                    onClick={() => {
                                        onExamTabClick("combined");
                                    }}
                                >
                                    Combined
                                </ExamButton>
                               </div> 
                            </Col>
                          
                        </OneLogoRow> */}
                        {/* <Row className='overviewColorRw' style={{ marginTop: 20, paddingLeft: 12 }}>
                            <div className='overviewColorClmLft'>
                            <Col style={{ width: 25, paddingTop: 8 }}>
                                <OverviewIcon src={CologG} />
                            </Col>
                            
                            <Col span={8}>
                                <span style={{ fontSize: 20, fontWeight: 600 }}>
                                    Overview
                                </span>
                            </Col>
                            </div>
                            <Col className='overviewColorClm' span={14} style={{ justifyContent: "flex-end", display: "flex" }}>
                                {EXAM_SCHOOLS.map(({ key, value }) => (
                                    <Tab
                                        bgColor={key == schoolType ? null : COLOR.orange100}
                                        active={key == schoolType}
                                        key={key}
                                        onClick={() => {
                                            onSchoolTypeChange(key);
                                        }}
                                    >
                                        {value}
                                    </Tab>
                                ))}
                            </Col>
                        </Row> */}
                        <Row>
                            <TotalNStudentTxt>{`Total number of student: ${isCombined ? activeGradesCombine.length : activeGradesSingle.length}`}</TotalNStudentTxt>
                        </Row>
                        <Row >
                            <Col  xl={5}>
                                <SearchBoxContainer>
                                    <SearchBox
                                        placeholder="Find your student"
                                        onChange={filterStudent}
                                    />
                                    <Search style={{ fontSize: 18 }} />
                                </SearchBoxContainer>
                                    {/* <SortingMenu grades={isCombined ? resultDataCombine.grades : resultData.grades} onFilter={filterStudentByClass} /> */}
                            </Col>
                            <Col xl={19}>
                            <div style={{ width: '100%',  }}>
                               {Charts}
                            </div>
                            </Col>
                            
                        </Row>
                        <div style={{ display: "flex", flex: 1 }}>

                            <ExamOverflowTwo>
                                        {/* <ExamGradeTable>
                                            <ExamGradeBoday>
                                                <Exam2TableHeader>
                                                    <ExamTableSection1 style={{ width: 220 }}>
                                                        <NameContent>Name</NameContent>
                                                    </ExamTableSection1>
                                                    <ExamTableSection2>
                                                        <TopTabCont>
                                                            <TableTopBtnCont style={{ width: 140 }}>
                                                                <HeaderTabP style={{ fontSize: 15, width: "90%", fontWeight: 600, borderRadius: '10px' }}>Placement</HeaderTabP>
                                                            </TableTopBtnCont>
                                                            {map(EXAM_LABELS, (key, index) => (<TableTopBtnCont key={key + index} style={{ width: getWidth(index) }}>
                                                                <TootipWrapper hasToolTip label={EXAM_LABELS_FULL[index]}>
                                                                    <HeaderTab key={key} style={{ fontSize: 12, textOverflow: "ellipsis", width: "90%", borderRadius:'10px' }}>{key}</HeaderTab>
                                                                </TootipWrapper>
                                                            </TableTopBtnCont>
                                                            ))}
                                                        </TopTabCont>
                                                    </ExamTableSection2>
                                                </Exam2TableHeader>
                                            </ExamGradeBoday>
                                        </ExamGradeTable> */}
                        {
                            modal && (
                                <RndWrapper className='ExamTableModalUpr'>
                                    <Rnd
                                        default={{
                                            x: isTablate && !isLandscape ? 50 : 100,
                                            y: isTablate && !isLandscape ? -400 : -200,
                                        }}
                                        bounds="window"
                                        enableResizing={false}
                                        style={{ zIndex: 1000 }}
                                    >
                                        <ModalWrapper className='ExamTableModal'>
                                            <CloseButtonWrapper>
                                                <CloseIcon onTouchStart={toggleModal} onClick={toggleModal} style={{ width: 20, height: 20, color: "white" }} />
                                            </CloseButtonWrapper>
                                            <PrintContent ref={printRef} className="to_be_print examTableModel">
                                        {loading ? (
                                            <div style={{ minWidth: '512px', minHeight:'493px' }}> 
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
                                                        <Skeleton.Input active size="small" style={{ width: '200px', height: '20px' }} />
                                                        <Skeleton.Input active size="small" style={{ width: '150px', height: '16px' }} />
                                                    </div>
                                                    <Skeleton.Avatar active size={25} shape="circle" />
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap', gap: '20px', marginTop: '10px' }}>
                                                    <div style={{ width: '100%' }}>
                                                        <Skeleton active title={false} paragraph={{ rows: 1, width: '100%' }} style={{ marginBottom: '10px' }} />
                                                        <Skeleton.Input active style={{ width: '100%', height: '20px', marginBottom: '10px' }} />
                                                        <Skeleton active title={false} paragraph={{ rows: 1, width: '100%' }} style={{ marginBottom: '15px' }} />
                                                        <div style={{  width: '100%', display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap' }}>
                                                            <Skeleton.Input active style={{ width: '150px', height: '28px', borderRadius: '38px' }} />
                                                            <Skeleton.Input active style={{ width: '180px', height: '28px', borderRadius: '38px' }} />
                                                        </div>
                                                    </div>
                                                    <div style={{ width: '100%', marginTop: '20px' }}>
                                                        <Skeleton active title={false} paragraph={{ rows: 1, width: '40%' }} style={{ marginBottom: '15px', textAlign: 'center' }} />
                                                        <Skeleton active title={false} paragraph={{ rows: 4, width: ['100%', '90%', '80%', '70%'] }} />
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', lineHeight: '1.2' }}>
                                                        <p style={{ fontSize: '14px', fontWeight: '600', color: '#252525', margin: '0px' }}>
                                                            {studentData?.studentData ? `${studentData.studentData.firstName} ${studentData.studentData.lastName} (Student)` : selectedStudent ? `${selectedStudent.firstName} ${selectedStudent.lastName} (Student)` : '(Student)'}
                                                        </p>
                                                        <p style={{ fontSize: '12px', fontWeight: '400', color: '#9CA3AF', margin: '0px' }}>
                                                            {studentData?.studentData?.schoolName || ''}
                                                        </p>
                                                    </div>
                                                    <PrintButtonWrapper onPointerDown={handlePrint}>
                                                        <PrintIcon sx={{ width: '18px', height: '18px' }} />
                                                    </PrintButtonWrapper>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                    <div style={{ width: '50%' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '5px' }}>
                                                            <p style={{ fontSize: '14px', fontWeight: '600', margin: '0' }} >Overall Performance</p>
                                                            <progress className="pill-progress" id="file" value={studentData?.overallPerformance || 0} max="100"> {studentData?.overallPerformance || 0}% </progress>
                                                            <p style={{ fontSize: '12px', fontWeight: '400', margin: '0px' }}>
                                                                {studentData?.band ? `Received a target of ${studentData.band} in a Exam ${examType === 'exam1' ? '1' : examType === 'exam2' ? '2' : examType === 'exam3' ? '3' : ''}.` : 'No data available'}
                                                            </p>
                                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', backgroundColor: getPriorityColor(studentData?.overallPerformance || 0), padding: '2px 10px', borderRadius: '38px' }}>
                                                                    <p style={{ fontSize: '12px', color: '#fff', lineHeight: '1.2', padding: '2px 4px', margin: '0' }}>{getPriorityText(studentData?.overallPerformance || 0)}</p>
                                                                    <InfoOutlineIcon onTouchStart={toggleFlagModal} onClick={toggleFlagModal} sx={{ color: '#000', width: '20px', height: '20px', cursor: 'pointer' }} />
                                                                </div>
                                                        <div style={{ border: '1px solid #000', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', padding: '2px 10px', borderRadius: '38px' }}>
                                                            <p style={{ fontSize: '12px', color: '#000', lineHeight: '1.2', padding: '2px 4px', margin: '0' }}>Compared to District Avg:-{studentData?.districtOverallPerformance || 0}%</p>
                                                        </div>
                                                            </div>
                                                </div>

                                            </div>
                                            <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                                                        <p style={{ fontSize: '14px', fontWeight: '600', margin: '0', textAlign: 'center' }} >Domains Needing Support</p>
                                                        <DomainsPerformanceChart data={domainsChartData} color={getPriorityColor(studentData?.overallPerformance || 0)} />
                                                
                                                {/* <div style={{ flexBasis: '50%', flexShrink: 0, flexGrow: 0 }}>
                                                    <div style={{ display: 'flex', flexDirection: "column", alignItems: 'flex-start' }}>
                                                        <p style={{ fontSize: '12px', fontWeight: '600', margin: '0px' }}>Suggested Next Steps:</p>
                                                        <div style={{ marginLeft: '20px' }}>
                                                            <ul>
                                                                <li style={{ fontSize: '12px', fontWeight: '600' }}>Provide PD on teaching informational text (RI.6.3)</li>
                                                                <li style={{ fontSize: '12px', fontWeight: '600' }}>Assign targeted small groups for RL.6.2</li>
                                                                <li style={{ fontSize: '12px', fontWeight: '600' }}>Monitor growth on writing standards (W.6.1)</li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div> */}



                                            </div>
                                        </div>
                                            </>
                                        )}
                                            </PrintContent>
                                        </ModalWrapper>
                                    </Rnd>
                                </RndWrapper>
                            )
                        }
                                
                            </ExamOverflowTwo>
                            
                        </div>
                        {!isCombined?<ViewGradeTable 
                                filteredusers_response={filteredusers_response} 
                                question_length={resultData.question_length}
                                toggleModal={toggleModal}
                                toggleFlagModal={toggleFlagModal}
                                openFlagModal={openFlagModal}
                                EXAM_LABELS={EXAM_LABELS}
                                EXAM_LABELS_FULL={EXAM_LABELS_FULL}
                                onViewSubmission={reviewDistrictAssignment}
                                />:<ViewGradeTableCombine 
                                toggleModal={toggleModal}
                                modal={modal}
                                toggleFlagModal={toggleFlagModal}
                                openFlagModal={openFlagModal}
                                filteredusers_response={filteredusers_response_combine} 
                                question_length={resultDataCombine.question_length}
                                studentData={studentData}
                                loading={loading}
                                examType={examType}
                                EXAM_LABELS={EXAM_LABELS}
                                EXAM_LABELS_FULL={EXAM_LABELS_FULL}
                                onViewSubmission={reviewDistrictAssignment}
                                />}
                    {/* </ExamGradeSec> */}
                </div>
        </Wrapper>
    </SentryWrap>
    );
};


export default ExamTable;
